<template>
	<b-card no-body>
		<b-row class="d-flex align-items-center justify-content-md-between p-3">
			<b-col cols="12" md="6" class="d-md-flex">
				<!-- <base-input v-model="filters.search.search_text" prepend-icon="fas fa-search" placeholder="Search" v-on:keydown.enter="searchByFilter()"></base-input> -->
				<base-input label="Search" v-model="searchQuery" v-on:input="debouncedHandler" prepend-icon="fas fa-search"
					placeholder="Search..."> </base-input>
			</b-col>
			<b-col cols="12" md="3">
				<b-button class="float-right px-3 py-2 mb-2 mb-md-0" variant="primary"
					@click="$refs.fees_and_charges_form_modal.show()">
					<i class="el-icon-circle-plus-outline"></i> Create New
				</b-button>
			</b-col>
		</b-row>

		<!-- TABLE LIST -->
		<div class="table-listings">
			<el-table ref="multipleTable" v-loading="is_loading" :data="queriedData" style="width: 100%;" :header-cell-style="{textAlign: 'left'}">

				<el-table-column prop="text" label="Type" sortable>
					<template slot-scope="scope">
						<p class="top-line">
							{{ scope.row.text }}
						</p>
					</template>
				</el-table-column>

				<el-table-column prop="setting" label="Default Value" sortable>
					<template slot-scope="scope">
						<p class="top-line">
							{{ parseFloat(_gHlp.getValue(scope.row,'setting',0)) | moneyFormatter }}
						</p>
					</template>
				</el-table-column>

				<el-table-column prop="description" label="Description" sortable>
					<template slot-scope="scope">
						<p class="top-line">
							{{ scope.row.description || '-' }}
							
						</p>
					</template>
				</el-table-column>

				<el-table-column width="55" fixed="right">
					<template slot-scope="scope">
						<el-dropdown :tabindex="scope.row.salutation_id" class="py-2">
							<b class="el-dropdown-link">
								<b-icon icon="three-dots-vertical">
								</b-icon>
							</b>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="$refs.fees_and_charges_form_modal.show(scope.row)">
									Edit
								</el-dropdown-item>
								<el-dropdown-item @click.native="remove(scope.row.id)">
									Delete
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>

				</el-table-column>
			</el-table>
		</div>

		<!-- FOOTER -->
		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap">
			<div class="d-flex align-items-center mb-3">
				<p class="card-category mb-0 text-secondary">
					Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
				</p>

				<span class="mb-0 ml-4">Rows:</span>

				<el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage" placeholder="Per page">
					<el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
						:value="item">
					</el-option>
				</el-select>

			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="total" @change="paginationChanged($event)">
			</base-pagination>
		</div>
		<FeesAndChargeFormModal ref="fees_and_charges_form_modal" @refresh="initComponent" />
	</b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { swal } from '@/assets/js/httpImports.js'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import FeesAndChargeFormModal from '@/views/Configurations/InitialProposalSettings/FeesAndChargesSetting/Modals/FeesAndChargeFormModal'
import { mapState, mapActions } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'

export default {
	mixins: [clientPaginationMixin],
	components: {
		FeesAndChargeFormModal,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
	},
	props: {
		available_group_access: Array
	},
	data() {
		return {
			is_loading: true,
			propsToSearch: ['name'],
			currentPage: 1,
			searchText: '',
			debouncedHandler: '',
			TableColumn: [{
				type: 'selection'
			}],
			tableData: [],
			pagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500]
			},
			is_show_detail: false,
		}
	},
	created() {
		this.initComponent()
	},
	methods: {
		...mapActions(useInvinityStore, ['getDropdownList', 'deleteDropdownList']),
		async initComponent() {
			this.is_loading = true;
			let resp = await this.getDropdownList('lec_other_payment');
			this.tableData = resp;
			this.is_loading = false;
		},
		paginationChanged(page)
		{
				this.pagination.currentPage = page
		},
		remove(id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					let resp = await this.deleteDropdownList(id);
					if (!_gHlp.isEmpty(resp)) {
						_gNotif.notifySuccess('<b>Fees & Charges:</b> - Successfully removed.', 10000, 'success');
						this.initComponent();
					}
					this.is_loading = false;
				}
			})
		}
	}
}
</script>